import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { CallbackResultType } from '../../../enums/CallbackResultType';
import { strings } from '../../../resources/strings';
import { ReportService } from '../../Reports/ReportService';
import { GetLensCertificateLabelInput } from './GetLensCertificateLabelInput';

export class GetLensCertificateLabelService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  fileHandle = (input: GetLensCertificateLabelInput, callback?: (resultType: CallbackResultType) => void) => {
    this.http.postToDownloadFile<GetLensCertificateLabelInput>(
      `${this.baseUrlSislogV2Api}/v2/lens-certificate-label/file`,
      input
    ).then(result => {
      this.report.download(result, `${strings.LabelsOfLensCertification}.zpl`);
      callback?.(CallbackResultType.Success);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
      callback?.(CallbackResultType.Error);
    });
  }

  pdfHandle = (input: GetLensCertificateLabelInput, callback?: (resultType: CallbackResultType) => void) => {
    this.http.postToDownloadFile<GetLensCertificateLabelInput>(
      `${this.baseUrlSislogV2Api}/v2/lens-certificate-label/pdf`,
      input
    ).then(result => {
      this.report.openPdf(result);
      callback?.(CallbackResultType.Success);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
      callback?.(CallbackResultType.Error);
    });
  }
}